import type { ComponentPropsWithoutRef } from "react";

type CourseListImageProps = Omit<
  ComponentPropsWithoutRef<"img">,
  "loading" | "decoding" | "fetchPriority"
> & {
  /** Only the single above-the-fold LCP candidate may opt into preload. */
  priority?: "lcp" | "deferred";
};

/** Keep below-fold course discovery images out of React's SSR preload queue. */
export function CourseListImage({
  priority = "deferred",
  ...imageProps
}: CourseListImageProps) {
  if (priority === "lcp") {
    return <img {...imageProps} loading="eager" fetchPriority="high" />;
  }

  return (
    <img
      {...imageProps}
      loading="lazy"
      decoding="async"
      fetchPriority="low"
    />
  );
}
